<div class="container-box">
  <app-table-header tableTitle="Menù BI" (btnUpdateClick)="loadMenuBi()"></app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="menuBiTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
